const KeenSlider = window.KeenSlider

const { setInitialised, useDots } = window.BAO.Carousel.plugins

class StickyProductsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    if (!this.els.slide?.exists) return

    const perView = 1.2
    const allIndicators = this.els.indicator?.exists
      ? this.els.indicator.elements
      : []
    const positions = Math.max(
      1,
      Math.ceil(allIndicators.length - perView) + 1,
    )
    const indicators = allIndicators.slice(0, positions)
    allIndicators.slice(positions).forEach((el) => el.remove())

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView,
          spacing: 0,
        },
        breakpoints: {
          '(min-width: 1023px)': {
            disabled: true,
          },
        },
      },
      [setInitialised(), useDots(indicators)],
    )
  }
}

if (!customElements.get('sticky-products-carousel')) {
  customElements.define('sticky-products-carousel', StickyProductsCarousel)
}
